import { render, staticRenderFns } from "./bsq.html?vue&type=template&id=3ad11a6f&"
import script from "./bsq.js?vue&type=script&lang=js&"
export * from "./bsq.js?vue&type=script&lang=js&"
import style0 from "./bsq.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports